import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            component: () => import("@/views/MainLayout.vue"),
            children: [
                {
                    path: "",
                    name: "home",
                    component: () => import("@/views/Home.vue")
                },
                {
                    path: "/report-update-data",
                    name: "report-update-data",
                    component: () =>
                        import("./components/Dashboard/ReportUpdateData.vue")
                },
                {
                    path: "/record-message",
                    name: "record-message",
                    component: () =>
                        import("./components/Dashboard/RecordMessage.vue")
                },
                //report
                {
                    path: "/dashboard-report",
                    name: "dashboard-report-layout",
                    component: () =>
                        import("./views/Dashboard/DashboardReportLayout.vue"),
                    children: [
                        {
                            path: "/report-group-product",
                            name: "report-group-product",
                            component: () =>
                                import(
                                    "./components/Dashboard/Report/DashboardReportGroupProduct.vue"
                                )
                        },
                        {
                            path: "/report-group-customer",
                            name: "report-group-customer",
                            component: () =>
                                import(
                                    "./components/Dashboard/Report/DashboardReportCustomer.vue"
                                )
                        },
                        {
                            path: "/report-product",
                            name: "report-product",
                            component: () =>
                                import(
                                    "./components/Dashboard/Report/DashboardReportProduct.vue"
                                )
                        },
                        {
                            path: "/report-invoice-sale",
                            name: "report-invoice-sale",
                            component: () =>
                                import(
                                    "./components/Dashboard/Report/DashboardReportInvoiceSale.vue"
                                )
                        }
                    ]
                },
                //invoice-report
                {
                    path: "/invoice-report",
                    name: "invoice-report",
                    component: () => import("./views/Order/InvoiceReport")
                },
                //promotion-report
                {
                    path: "/promotion-report",
                    name: "promotion-report",
                    component: () => import("./views/Order/PromotionReport")
                },
                //overview
                {
                    path: "/overview",
                    name: "overview",
                    props: true,
                    component: () =>
                        import("./views/warehouse/OverviewLayout.vue"),
                    children: [
                        {
                            path: "/overview",
                            name: "overview-list",
                            component: () =>
                                import(
                                    "./components/Overview/ReservationsTable.vue"
                                )
                        },
                        {
                            path: "/overview_sale",
                            name: "overview-per-sale",
                            component: () =>
                                import(
                                    "./components/Overview/ReservationsSaleTable.vue"
                                )
                        }
                    ]
                },
                //products
                {
                    path: "/products",
                    name: "products",
                    props: true,
                    component: () =>
                        import("./views/warehouse/ProductsLayout.vue"),
                    children: [
                        {
                            path: "/products",
                            name: "product-list",
                            component: () =>
                                import(
                                    "./components/Products/ProductList/ProductsList.vue"
                                )
                        },
                        {
                            path: "/import_products",
                            name: "import-products",
                            component: () =>
                                import(
                                    "./components/Products/Import/ImportProductsList.vue"
                                )
                        },
                        {
                            path: "/export_products",
                            name: "export-products",
                            component: () =>
                                import(
                                    "./components/Products/Export/ExportProductsList.vue"
                                )
                        },
                        {
                            path: "/products_type",
                            name: "products-type",
                            component: () =>
                                import(
                                    "./components/Products/ProductList/ProductsType.vue"
                                )
                        },
                        {
                            path: "/products_invoice",
                            name: "products_invoice-type",
                            component: () =>
                                import(
                                    "./components/Products/ProductList/ProductsInvoice.vue"
                                )
                        }
                    ]
                },
                {
                    path: "/products_type_info/:id",
                    name: "products-type-info",
                    props: true,
                    component: () =>
                        import(
                            "./components/Products/ProductList/ProductsTypeCreate.vue"
                        )
                },
                {
                    path: "/factory_type_info/:id",
                    name: "factory-type-info",
                    props: true,
                    component: () =>
                        import("./components/Factory/FactoryTypeCreate")
                },
                //products-stock
                {
                    path: "/products-stock",
                    name: "products-stock",
                    props: true,
                    component: () => import("./views/Stock/StockLayout.vue"),
                    children: [
                        {
                            path: "/products-stock",
                            name: "product-stock-list",
                            component: () =>
                                import(
                                    "./components/Products/ProductList/ProductsStockList.vue"
                                )
                        }
                    ]
                },
                //user-management
                {
                    path: "/user-management",
                    name: "user-management",
                    props: true,
                    component: () => import("./views/Person/UserLayout.vue"),
                    children: [
                        {
                            path: "/user-management",
                            name: "user-management-list",
                            component: () =>
                                import("./components/Person/User/UserList.vue")
                        }
                    ]
                },
                {
                    path: "/user-information",
                    name: "user-information",
                    props: true,
                    component: () =>
                        import("./components/Person/User/UserInformation.vue")
                },
                {
                    path: "/products-information",
                    name: "products-information",
                    props: true,
                    component: () =>
                        import(
                            "./components/Products/ProductList/ProductsInformation.vue"
                        )
                },
                //materials
                {
                    path: "/materials",
                    name: "materials",
                    props: true,
                    component: () =>
                        import("./views/warehouse/MaterialsLayout.vue"),
                    children: [
                        {
                            path: "/materials",
                            name: "materials-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Materials/MaterialList/MaterialsList.vue"
                                )
                        },
                        {
                            path: "/materials-import",
                            name: "materials-import",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Materials/Import/MaterialsImportList.vue"
                                )
                        },
                        {
                            path: "/materials-export",
                            name: "materials-export",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Materials/Export/MaterialsExportList.vue"
                                )
                        },
                        {
                            path: "/materials-type",
                            name: "materials-type",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Materials/MaterialList/MaterialTypeList.vue"
                                )
                        }
                    ]
                },
                {
                    path: "/report-compare-product",
                    name: "report_compare_product",
                    component: () =>
                        import(
                            "./components/Dashboard/Report/DashboardReportDateProduct.vue"
                        )
                },
                {
                    path: "/product-standard",
                    name: "product_standard",
                    component: () =>
                        import("./views/Standard/ProductStandardLayout.vue"),
                    children: [
                        {
                            path: "/product-standard1",
                            name: "",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Standard/ProductStandard1.vue"
                                )
                        },
                        {
                            path: "/product-standard2",
                            name: "",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Standard/ProductStandard2.vue"
                                )
                        },
                        {
                            path: "/product-standard3",
                            name: "",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Standard/ProductStandard3.vue"
                                )
                        }
                    ]
                },
                {
                    path: "/product-cost",
                    name: "product_cost",
                    component: () =>
                        import("./views/Standard/ProductCostLayout.vue"),
                    children: [
                        {
                            path: "/product-cost1",
                            name: "",
                            props: true,
                            component: () =>
                                import("./components/Standard/ProductCost1.vue")
                        },
                        {
                            path: "/product-cost2",
                            name: "",
                            props: true,
                            component: () =>
                                import("./components/Standard/ProductCost2.vue")
                        },
                        {
                            path: "/product-cost3",
                            name: "",
                            props: true,
                            component: () =>
                                import("./components/Standard/ProductCost3.vue")
                        },
                        {
                            path: "/product-cost4",
                            name: "",
                            props: true,
                            component: () =>
                                import("./components/Standard/ProductCost4.vue")
                        },
                        {
                            path: "/product-cost5",
                            name: "",
                            props: true,
                            component: () =>
                                import("./components/Standard/ProductCost5.vue")
                        },
                        {
                            path: "/product-cost6",
                            name: "",
                            props: true,
                            component: () =>
                                import("./components/Standard/ProductCost6.vue")
                        }
                    ]
                },
                {
                    path: "/product-weight",
                    name: "product_weight",
                    component: () =>
                        import("./views/Standard/ProductWeightLayout.vue"),
                    children: [
                        {
                            path: "/product-weight1",
                            name: "",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Standard/ProductWeight1.vue"
                                )
                        },
                        {
                            path: "/product-weight2",
                            name: "",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Standard/ProductWeight2.vue"
                                )
                        },
                        {
                            path: "/product-weight3",
                            name: "",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Standard/ProductWeight3.vue"
                                )
                        },
                        {
                            path: "/product-weight4",
                            name: "",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Standard/ProductWeight4.vue"
                                )
                        },
                        {
                            path: "/product-weight5",
                            name: "",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Standard/ProductWeight5.vue"
                                )
                        }
                    ]
                },
                {
                    path: "/materials-information",
                    name: "materials-information",
                    props: true,
                    component: () =>
                        import(
                            "./components/Materials/MaterialList/MaterialsInformation.vue"
                        )
                },
                //factorial_material
                {
                    path: "",
                    name: "factorial_material",
                    props: true,
                    component: () =>
                        import("./views/warehouse/FactorialMaterialLayout.vue"),
                    children: [
                        {
                            path: "/factorial-material-list",
                            name: "factorial-material-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Materials/FactorialMaterial/FactorialMaterialList.vue"
                                )
                        },
                        {
                            path: "/factorial-material-import",
                            name: "factorial-material-import",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Materials/ImportFactorial/FactorialMaterialImportList.vue"
                                )
                        },
                        {
                            path: "/factorial-material-export",
                            name: "factorial-material-export",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Materials/ExportFactorial/FactorialMaterialExportList.vue"
                                )
                        },
                        {
                            path: "/factory-type-special",
                            name: "factory-type-special",
                            props: true,
                            component: () =>
                                import("./components/Factory/FactoryType.vue")
                        }
                    ]
                },
                {
                    path: "factorial-material-information",
                    name: "factorial-material-information",
                    props: true,
                    component: () =>
                        import(
                            "./components/Materials/FactorialMaterial/FactorialMaterialInformation.vue"
                        )
                },
                //person
                {
                    path: "",
                    name: "customer-vendor",
                    props: true,
                    component: () =>
                        import("./views/Person/CustomerLayout.vue"),
                    children: [
                        {
                            path: "/customer",
                            name: "customer",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/Customer/CustomerList.vue"
                                )
                        },
                        {
                            path: "/customer-other",
                            name: "customer-other",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/Customer/CustomerOtherList.vue"
                                )
                        },
                        {
                            path: "/vendor",
                            name: "vendor",
                            props: true,
                            component: () =>
                                import("./components/Person/Vendors/Vendor.vue")
                        },
                        {
                            path: "/special-customer",
                            name: "special-customer",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/ReportSpecialCustomer/SpecialCustomerList.vue"
                                )
                        }
                    ]
                },
                {
                    path: "/customer-information",
                    name: "customer-information",
                    props: true,
                    component: () =>
                        import(
                            "./components/Person/Customer/CustomerInformation.vue"
                        )
                },
                {
                    path: "/vendor-information",
                    name: "vendor-information",
                    props: true,
                    component: () =>
                        import(
                            "./components/Person/Vendors/VendorInformation.vue"
                        )
                },
                {
                    path: "/special-customer-form",
                    name: "special-customer-form",
                    props: true,
                    component: () =>
                        import(
                            "./components/Person/ReportSpecialCustomer/SpecialCustomerForm.vue"
                        )
                },
                //Order
                {
                    path: "",
                    name: "orders-menu",
                    props: true,
                    component: () => import("./views/Order/OrderLayout.vue"),
                    children: [
                        {
                            path: "/orders",
                            name: "orders",
                            props: true,
                            component: () =>
                                import("./components/Order/Order/OrderList.vue")
                        },
                        {
                            path: "/invoices",
                            name: "invoices",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Order/Invoice/InvoiceList.vue"
                                )
                        },
                        {
                            path: "/save-exportation",
                            name: "save-exportation",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Order/Invoice/SaveExportationList.vue"
                                )
                        },
                        {
                            path: "/example-product",
                            name: "example-product",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Order/ExampleProduct/ExampleProductList.vue"
                                )
                        },
                        {
                            path: "/example-gift",
                            name: "example-gift",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Order/ExampleGift/ExampleGiftList.vue"
                                )
                        }
                    ]
                },
                {
                    path: "",
                    name: "overview-sale",
                    props: true,
                    component: () =>
                        import("./views/Order/OverviewSaleLayout.vue"),
                    children: [
                        {
                            path: "/overview-sale-list",
                            name: "overview-sale-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Order/Overview/OverviewSaleList.vue"
                                )
                        },
                        {
                            path: "/transport-fee-report",
                            name: "transport-fee-report",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Order/Overview/TransportFeeReport.vue"
                                )
                        },
                        {
                            path: "/tax-driver-report",
                            name: "tax-driver-report",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Order/Overview/TaxDriverReport.vue"
                                )
                        },
                        {
                            path: "/dashboard-selling",
                            name: "dashboard-selling",
                            component: () =>
                                import(
                                    "./components/Dashboard/DashboardSelling.vue"
                                )
                        }
                    ]
                },
                {
                    path: "",
                    name: "stock-product-for-sale",
                    props: true,
                    component: () =>
                        import("./views/Order/StockProductLayout.vue"),
                    children: [
                        {
                            path: "/stock-product",
                            name: "stock-product",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Order/Overview/StorkProductList.vue"
                                )
                        }
                    ]
                },
                {
                    path: "/",
                    name: "promotions",
                    props: true,
                    component: () =>
                        import("./views/Promotions/PromotionsLayout.vue"),
                    children: [
                        {
                            path: "/promotions",
                            name: "promotions-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Order/Promotions/PromotionList.vue"
                                )
                        },
                        {
                            path: "/promotions-other",
                            name: "promotions-other-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Order/Promotions/PromotionOtherList.vue"
                                )
                        }
                    ]
                },
                {
                    path: "/promotions-other-form",
                    name: "promotions-other-form",
                    props: true,
                    component: () =>
                        import(
                            "./components/Order/Promotions/PromotionOtherForm.vue"
                        )
                },
                {
                    path: "/promotions-form",
                    name: "promotions-form",
                    props: true,
                    component: () =>
                        import(
                            "./components/Order/Promotions/PromotionForm.vue"
                        )
                },
                {
                    path: "/order",
                    name: "order-form",
                    props: true,
                    component: () =>
                        import("./components/Order/Order/OrderForm.vue")
                },
                {
                    path: "/order-detail",
                    name: "order-detail",
                    props: true,
                    component: () =>
                        import("./components/Order/Order/OrderShow.vue")
                },
                {
                    path: "/invoice",
                    name: "invoice-form",
                    props: true,
                    component: () =>
                        import("./components/Order/Invoice/InvoiceForm.vue")
                },
                {
                    path: "/promotion-form",
                    name: "promotion-form",
                    props: true,
                    component: () =>
                        import(
                            "./components/Order/Promotions/PromotionForm.vue"
                        )
                },
                {
                    path: "/save-exportation-form",
                    name: "save-exportation-form",
                    props: true,
                    component: () =>
                        import(
                            "./components/Order/Invoice/SaveExportationForm.vue"
                        )
                },
                //SaleReturnProduct
                {
                    path: "/",
                    name: "/sale-return-products-layout",
                    props: true,
                    component: () =>
                        import(
                            "./views/SaleReturnProducts/SaleReturnProductsLayout.vue"
                        ),
                    children: [
                        {
                            path: "/sale-return-products",
                            name: "sale-return-products-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Order/SaleReturnProducts/SaleReturnProductsList.vue"
                                )
                        },
                        {
                            path: "/sale-return-credit",
                            name: "sale-return-credit-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Order/SaleReturnProducts/SaleReturnCreditList.vue"
                                )
                        }
                    ]
                },
                {
                    path: "/sale-return-products-form1",
                    name: "sale-return-products-form1",
                    props: true,
                    component: () =>
                        import(
                            "./components/Order/SaleReturnProducts/SaleReturnProductsForm.vue"
                        )
                },
                {
                    path: "/sale-return-products-form2",
                    name: "sale-return-products-form2",
                    props: true,
                    component: () =>
                        import(
                            "./components/Order/SaleReturnProducts/SaleReturnProductsForm2.vue"
                        )
                },
                //quota
                {
                    path: "/quota",
                    name: "quota",
                    props: true,
                    component: () => import("./views/Quota/index.vue"),
                    children: [
                        {
                            path: "/quota-config",
                            name: "quota-config",
                            props: true,
                            component: () =>
                                import("./components/Quota/QuotaConfig.vue")
                        },
                        {
                            path: "/quota-list",
                            name: "quota-list",
                            props: true,
                            component: () =>
                                import("./components/Quota/QuotaList.vue")
                        },
                        {
                            path: "/quota-sale-list",
                            name: "quota-sale-list",
                            props: true,
                            component: () =>
                                import("./components/QuotaSale/QuotaSale.vue")
                        },
                        {
                            path: "/quota-sale-create",
                            name: "quota-sale-create",
                            props: true,
                            component: () =>
                                import(
                                    "./components/QuotaSale/QuotaSaleCreate.vue"
                                )
                        },
                        {
                            path: "/quota-sale-history",
                            name: "quota-sale-history",
                            props: true,
                            component: () =>
                                import(
                                    "./components/QuotaSale/QuotaSaleHistory.vue"
                                )
                        }
                    ]
                },
                //quota-sale
                // {
                //     path: "/quota-sale",
                //     name: "quota",
                //     props: true,
                //     component: () => import("./views/QuotaSale/index.vue"),
                //     children: [
                //
                //     ]
                // },
                {
                    path: "/quota-create",
                    name: "quota-create",
                    props: true,
                    component: () => import("./components/Quota/QuotaForm.vue")
                },
                {
                    path: "/quota-sale",
                    name: "quota-sale",
                    props: true,
                    component: () => import("./components/Quota/QuotaSale.vue")
                },
                {
                    path: "/quota-history",
                    name: "quota-history",
                    props: true,
                    component: () =>
                        import("./components/Quota/QuotaHistory.vue")
                },
                //Sheet
                {
                    path: "/sheet",
                    name: "sheet",
                    props: true,
                    component: () =>
                        import("./views/warehouse/SheetLayout.vue"),
                    children: [
                        {
                            path: "/sheet",
                            name: "sheet-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Sheet/SheetsList/SheetList.vue"
                                )
                        },
                        {
                            path: "/sheet-import",
                            name: "sheet-import",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Sheet/Import/SheetImport.vue"
                                )
                        },
                        {
                            path: "/sheet-export",
                            name: "sheet-export",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Sheet/Export/SheetExport.vue"
                                )
                        },
                        {
                            path: "/sheet-type",
                            name: "sheet-type",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Sheet/SheetType/SheetTypeList.vue"
                                )
                        }
                    ]
                },
                {
                    path: "/sheet-information",
                    name: "sheet-information",
                    props: true,
                    component: () =>
                        import(
                            "./components/Sheet/SheetsList/SheetInformation.vue"
                        )
                },
                //Report
                {
                    path: "/report",
                    name: "report",
                    props: true,
                    component: () =>
                        import("./views/warehouse/ReportLayout.vue"),
                    children: [
                        {
                            path: "/production-report",
                            name: "production-report",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Report/Product/ProductionReportList.vue"
                                )
                        },
                        {
                            path: "/sheet-report",
                            name: "sheet-report",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Report/Sheet/SheetReportList.vue"
                                )
                        },
                        {
                            path: "/machine-product",
                            name: "machine-product",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Report/Machine/MachineProductList.vue"
                                )
                        },
                        {
                            path: "/machine-sheet",
                            name: "machine-sheet",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Report/Machine/MachineSheetList.vue"
                                )
                        }
                    ]
                },
                {
                    path: "/sheet-report-information",
                    name: "sheet-report-information",
                    props: true,
                    component: () =>
                        import(
                            "./components/Report/Sheet/SheetReportInformation.vue"
                        )
                },
                {
                    path: "/production-report-information",
                    name: "production-report-information",
                    props: true,
                    component: () =>
                        import(
                            "./components/Report/Product/ProductionReportInformation.vue"
                        )
                },
                {
                    path: "/machine-product-form",
                    name: "machine-product-form",
                    props: true,
                    component: () =>
                        import(
                            "./components/Report/Machine/MachineProductForm.vue"
                        )
                },
                {
                    path: "/machine-sheet-form",
                    name: "machine-sheet-form",
                    props: true,
                    component: () =>
                        import(
                            "./components/Report/Machine/MachineSheetForm.vue"
                        )
                },
                //Material Inspection
                {
                    path: "/material-inspection",
                    name: "material-inspection",
                    props: true,
                    component: () =>
                        import("./views/SaleManagement/MaterialInspectLayout"),
                    children: [
                        {
                            path: "/day-shift",
                            name: "day-shift",
                            props: true,
                            component: () =>
                                import(
                                    "./components/SaleManagement/MaterialInspect/DayShiftList"
                                )
                        },
                        {
                            path: "/night-shift",
                            name: "night-shift",
                            props: true,
                            component: () =>
                                import(
                                    "./components/SaleManagement/MaterialInspect/NightShiftList"
                                )
                        }
                    ]
                },
                {
                    path: "/checked-list",
                    name: "check-lists",
                    props: true,
                    component: () =>
                        import("./views/SaleManagement/CheckedListLayout"),
                    children: [
                        {
                            path: "/checked-list",
                            name: "checked-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/SaleManagement/Checked/CheckedList"
                                )
                        }
                    ]
                },
                //PO
                {
                    path: "/po",
                    name: "po",
                    props: true,
                    component: () =>
                        import("./views/SaleManagement/PurchaseOrderLayout"),
                    children: [
                        {
                            path: "/pre-order",
                            name: "pre-order",
                            props: true,
                            component: () =>
                                import(
                                    "./components/SaleManagement/PurchaseOrder/PreOrderList"
                                )
                        },
                        {
                            path: "/purchase-order",
                            name: "purchase-order",
                            props: true,
                            component: () =>
                                import(
                                    "./components/SaleManagement/PurchaseOrder/PurchaseOrderList"
                                )
                        }
                    ]
                },
                {
                    path: "/purchase-form",
                    name: "purchase-form",
                    props: true,
                    component: () =>
                        import(
                            "./components/SaleManagement/PurchaseOrder/PurchaseOrderForm"
                        )
                },
                //RR
                {
                    path: "/rr",
                    name: "rr",
                    props: true,
                    component: () => import("./views/SaleManagement/RrLayout"),
                    children: [
                        {
                            path: "/rr-list",
                            name: "rr-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/SaleManagement/RR/RROrderList"
                                )
                        }
                    ]
                },
                {
                    path: "",
                    name: "payment",
                    props: true,
                    component: () =>
                        import("./views/SaleManagement/PaymentLayout"),
                    children: [
                        {
                            path: "/payment-list",
                            name: "payment-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/SaleManagement/Payment/PaymentList"
                                )
                        }
                    ]
                },
                {
                    path: "/payment-form",
                    name: "payment-form",
                    props: true,
                    component: () =>
                        import(
                            "./components/SaleManagement/Payment/PaymentForm"
                        )
                },
                {
                    path: "/rr-form",
                    name: "rr-form",
                    props: true,
                    component: () =>
                        import("./components/SaleManagement/RR/RROrderForm")
                },
                {
                    path: "/rr-form-details",
                    name: "rr-form-details",
                    props: true,
                    component: () =>
                        import(
                            "./components/SaleManagement/RR/RROrderFormDetails"
                        )
                },
                //Transportation
                {
                    path: "/driver",
                    name: "driver-layout",
                    props: true,
                    component: () =>
                        import("./views/Transportation/DriverLayout"),
                    children: [
                        {
                            path: "/driver",
                            name: "driver",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Transportation/Driver/DriverList"
                                )
                        },
                        {
                            path: "/driver-bonus",
                            name: "driver-bonus",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Transportation/Driver/DriverBonusList"
                                )
                        },
                        {
                            path: "/driver-transport-report",
                            name: "driver-transport-report",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Transportation/Driver/DriverTransportReportList"
                                )
                        },
                        {
                            path: "/driver-config-bonus",
                            name: "driver-config=bonus",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Transportation/Driver/DriverConfigBonus"
                                )
                        },
                        {
                            path: "/driver-config-province",
                            name: "driver-config=province",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Transportation/Driver/DriverConfigProvince"
                                )
                        }
                    ]
                },
                {
                    path: "/driver-form",
                    name: "driver-form",
                    props: true,
                    component: () =>
                        import("./components/Transportation/Driver/DriverForm")
                },
                {
                    path: "/driver-shipping",
                    name: "driver-shipping",
                    props: true,
                    component: () =>
                        import(
                            "./components/Transportation/Driver/DriverShipping"
                        )
                },

                {
                    path: "/transportation",
                    name: "transportation-layout",
                    props: true,
                    component: () =>
                        import("./views/Transportation/TransportLayout"),
                    children: [
                        {
                            path: "/transportation",
                            name: "transportation",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Transportation/Transport/TransportList"
                                )
                        }
                    ]
                },
                {
                    path: "/transportation-form",
                    name: "transportation-form",
                    props: true,
                    component: () =>
                        import(
                            "./components/Transportation/Transport/TransportForm"
                        )
                },

                {
                    path: "",
                    name: "account-layout",
                    props: true,
                    component: () =>
                        import("./views/Transportation/AccountTransportLayout"),
                    children: [
                        {
                            path: "/insurance-fee",
                            name: "insurance-fee",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Transportation/Account/InsuranceList"
                                )
                        },
                        {
                            path: "/deposit",
                            name: "deposit",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Transportation/Account/DepositList"
                                )
                        },
                        {
                            path: "/cost-repair",
                            name: "cost-repair",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Transportation/Account/RepairList"
                                )
                        },
                        {
                            path: "/cost-damages",
                            name: "cost-damages",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Transportation/Account/DamagesList"
                                )
                        },
                        {
                            path: "/car-fee",
                            name: "car-fee-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Transportation/Account/CarFeeList"
                                )
                        }
                    ]
                },
                {
                    path: "/car-fee-information",
                    name: "car-fee-information",
                    props: true,
                    component: () =>
                        import(
                            "./components/Transportation/Account/CarFeeInformation"
                        )
                },
                {
                    path: "/insurance-information",
                    name: "insurance-information",
                    props: true,
                    component: () =>
                        import(
                            "./components/Transportation/Account/InsuranceInformation"
                        )
                },
                {
                    path: "/deposit-information",
                    name: "deposit-information",
                    props: true,
                    component: () =>
                        import(
                            "./components/Transportation/Account/DepositInformation"
                        )
                },
                {
                    path: "/damages-information",
                    name: "damages-information",
                    props: true,
                    component: () =>
                        import(
                            "./components/Transportation/Account/DamagesInformation"
                        )
                },
                {
                    path: "",
                    name: "shipping-layout",
                    props: true,
                    component: () =>
                        import("./views/Transportation/ShippingLayout"),
                    children: [
                        {
                            path: "/shipping-fee",
                            name: "shipping-fee",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Transportation/Shipping/ShippingFeeList"
                                )
                        },
                        {
                            path: "/transport-fee",
                            name: "transport-fee",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Transportation/Shipping/TransportFeeList"
                                )
                        },
                        {
                            path: "/shipping-fee-sub",
                            name: "shipping-fee-sub",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Transportation/Shipping/ShippingFeeSubList"
                                )
                        },
                        {
                            path: "/transport-fee-sub",
                            name: "transport-fee-sub",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Transportation/Shipping/TransportFeeSubList"
                                )
                        },
                        {
                            path: "/edit-shipping",
                            name: "edit-shipping",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Transportation/Shipping/EditShippingTable"
                                )
                        },
                        {
                            path: "/shipping-report",
                            name: "shipping-report",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Transportation/Shipping/ShippingReport"
                                )
                        }
                    ]
                },
                {
                    path: "",
                    name: "checkbag-layout",
                    props: true,
                    component: () =>
                        import("./views/SaleManagement/CheckedBagLayout"),
                    children: [
                        {
                            path: "/checked-bag",
                            name: "checked-bag",
                            props: true,
                            component: () =>
                                import(
                                    "./components/SaleManagement/CheckedBag/CheckBag"
                                )
                        },
                        {
                            path: "/bag-type",
                            name: "bag-type",
                            props: true,
                            component: () =>
                                import(
                                    "./components/SaleManagement/CheckedBag/BagType"
                                )
                        }
                    ]
                },

                // Accounting
                // Billing.
                {
                    path: "/accounting/billing",
                    props: true,
                    component: () =>
                        import("./views/Accounting/AccountingBillingLayout"),
                    children: [
                        {
                            path: "sellers",
                            name: "sellers",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/Billing/Sellers"
                                )
                        },
                        {
                            path: "receivable",
                            name: "receivable",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/Billing/Receivables"
                                )
                        },
                        {
                            path: "billings",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/Billing/BillingTabs"
                                ),
                            children: [
                                {
                                    path: "/",
                                    name: "billingsStatusAll",
                                    props: {
                                        statusId: 0
                                    },
                                    component: () =>
                                        import(
                                            "./components/Accounting/Billing/Billings"
                                        )
                                },
                                {
                                    path: "status/:statusId",
                                    name: "billingsByStatus",
                                    props: true,
                                    component: () =>
                                        import(
                                            "./components/Accounting/Billing/Billings"
                                        )
                                }
                            ]
                        },
                        {
                            path: "payments",
                            name: "payments",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/Billing/Payments"
                                )
                        }
                    ]
                },
                // Billing Payoff.
                {
                    path: "/accounting",
                    props: true,
                    component: () =>
                        import(
                            "./views/Accounting/AccountingBillingPayoffLayout"
                        ),
                    children: [
                        {
                            path: "payoff",
                            name: "payoff-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/Payoff/PayoffList"
                                )
                        },
                        {
                            path: "cheque-list",
                            name: "cheque-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/Payoff/ChequeList"
                                )
                        },
                        {
                            path: "invoice-payoff-account",
                            name: "invoice-payoff-account",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/InvoicePayoff/InvoicePayoffAccountList.vue"
                                )
                        },
                        {
                            path: "invoice-payoff-other",
                            name: "invoice-payoff-other",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/InvoicePayoff/InvoicePayoffOtherList.vue"
                                )
                        }
                        // {
                        //     path: "create",
                        //     name: "billingPayoffsForm",
                        //     props: true,
                        //     component: () =>
                        //         import("./components/Accounting/BillingPayoff/BillingPayoffForm")
                        // },
                        // {
                        //     path: "/",
                        //     props: true,
                        //     component: () =>
                        //         import("./components/Accounting/BillingPayoff/BillingPayoffTabs"),
                        //     children: [
                        //         {
                        //             path: "/",
                        //             name: "billingPayoffsAll",
                        //             props: {
                        //                 transactionTypeId: 'all'
                        //             },
                        //             component: () =>
                        //                 import("./components/Accounting/BillingPayoff/BillingPayoffs")
                        //         },
                        //         {
                        //             path: "cancelled",
                        //             name: "billingPayoffsCancelled",
                        //             props: {
                        //                 transactionTypeId: 'cancelled'
                        //             },
                        //             component: () =>
                        //                 import("./components/Accounting/BillingPayoff/BillingPayoffs")
                        //         },
                        //         {
                        //             path: "transaction-type/:transactionTypeId",
                        //             name: "billingPayoffsByTransactionType",
                        //             props: true,
                        //             component: () =>
                        //                 import("./components/Accounting/BillingPayoff/BillingPayoffs")
                        //         },
                        //     ]
                        // }
                    ]
                },
                {
                    path: "/invoice-payoff",
                    name: "invoice-payoff",
                    props: true,
                    component: () =>
                        import(
                            "./components/Accounting/InvoicePayoff/InvoicePayoffForm.vue"
                        )
                },
                {
                    path: "/invoice-payoff-transactions",
                    name: "invoice-payoff-transactions",
                    props: true,
                    component: () =>
                        import(
                            "./components/Accounting/InvoicePayoff/InvoicePayoffTransaction.vue"
                        )
                },
                {
                    path: "/invoice-payoff-other-form",
                    name: "invoice-payoff-other-form",
                    props: true,
                    component: () =>
                        import(
                            "./components/Accounting/InvoicePayoff/InvoicePayoffOtherForm.vue"
                        )
                },
                {
                    path: "/invoice-payoff-other-transactions",
                    name: "invoice-payoff-other-transactions",
                    props: true,
                    component: () =>
                        import(
                            "./components/Accounting/InvoicePayoff/InvoicePayoffTransactionModal.vue"
                        )
                },
                {
                    path: "/",
                    props: true,
                    component: () =>
                        import(
                            "./views/Accounting/AccountBillingPaymentLayout.vue"
                        ),
                    children: [
                        {
                            path: "/accounting/rr-payoff/payment",
                            name: "rr-payoff-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/BillingPayment/RRPayoffList.vue"
                                )
                        },
                        {
                            path: "/accounting/rr-payoff/payoff",
                            name: "wait-Payment",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/BillingPayment/WaitingPayment.vue"
                                )
                        },
                        {
                            path: "/accounting/rr-payoff/account",
                            name: "account",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/BillingPayment/Account.vue"
                                )
                        },
                        {
                            path: "/accounting/rr-payoff/cheque",
                            name: "rr-payoff-cheque",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/BillingPayment/ChequeRRPayoffList.vue"
                                )
                        },
                        {
                            path: "/accounting/rr-payoff/mile-seller",
                            name: "mile-seller",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/BillingPayment/MileSellerCarList.vue"
                                )
                        },
                        {
                            path: "/accounting/rr-payoff/driver-payment-report",
                            name: "driver-payment-report",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/BillingPayment/DriverPaymentReport.vue"
                                )
                        }
                    ]
                },
                {
                    path: "/accounting/rr-payoff/form1",
                    name: "payment-form1",
                    props: true,
                    component: () =>
                        import(
                            "./components/Accounting/BillingPayment/RRPayoffForm1.vue"
                        )
                },
                {
                    path: "/accounting/rr-payoff/other",
                    name: "payoff-other",
                    props: true,
                    component: () =>
                        import(
                            "./components/Accounting/BillingPayment/RRPayoffOtherForm.vue"
                        )
                },
                {
                    path: "/accounting/payoff/po",
                    name: "payoff-po",
                    props: true,
                    component: () =>
                        import(
                            "./components/Accounting/BillingPayment/PayoffPO.vue"
                        )
                },
                {
                    path: "/accounting/payoff/payment-project",
                    name: "payment-project",
                    props: true,
                    component: () =>
                        import(
                            "./components/Accounting/BillingPayment/ProjectPayment.vue"
                        )
                },
                //  ธนาคาร
                {
                    path: "/",
                    props: true,
                    component: () =>
                        import("./views/Accounting/BankLayout.vue"),
                    children: [
                        {
                            path: "/accounting/Bank",
                            name: "bank-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/Bank/BankList.vue"
                                )
                        },
                        {
                            path: "/accounting/bank-branch",
                            name: "bank-branch",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/BankBranch/BankBranchTable"
                                )
                        }
                    ]
                },
                {
                    path: "/",
                    props: true,
                    component: () => import("./views/Accounting/TaxLayout.vue"),
                    children: [
                        {
                            path: "/accounting/tax-invoice",
                            name: "tax-invoice-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/Tax/TaxInvoiceList.vue"
                                )
                        },
                        {
                            path: "/accounting/tax-payment",
                            name: "tax-payment-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/Tax/TaxPaymentList.vue"
                                )
                        },
                        {
                            path: "/accounting/tax-payoff",
                            name: "tax-payoff-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/Tax/TaxRRPayoffList.vue"
                                )
                        },
                        {
                            path: "/accounting/billing-RE",
                            name: "billing-RE-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/Tax/BillingREList.vue"
                                )
                        },
                        {
                            path: "/accounting/tax-payment-account",
                            name: "tax-payment-account",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/Tax/TaxPaymentAccount.vue"
                                )
                        },
                        {
                            path: "/accounting/credit-note",
                            name: "credit-note",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/CreditNote/CreditNoteList.vue"
                                )
                        },
                        {
                            path: "/accounting/tax-customer",
                            name: "tax-customer",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/Tax/taxCustomer.vue"
                                )
                        },
                        {
                            path: "/accounting/tax-customer-info",
                            name: "tax-customer-info",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/Tax/taxCustomerInfo.vue"
                                )
                        }
                    ]
                },
                {
                    path: "/accounting/tax-customer-form/:id",
                    name: "tax-invoice-form",
                    props: true,
                    component: () =>
                        import(
                            "./components/Accounting/Tax/TaxCustomerForm.vue"
                        )
                },
                {
                    path: "/accounting/tax-customer-form-create/:id",
                    name: "tax-invoice-form-create",
                    component: () =>
                        import(
                            "./components/Accounting/Tax/TaxCustomerFormCreate.vue"
                        ),
                    props: true
                },
                {
                    path: "/accounting/tax-invoice-form",
                    name: "tax-invoice-form",
                    props: true,
                    component: () =>
                        import("./components/Accounting/Tax/TaxInvoiceForm.vue")
                },
                {
                    path: "/accounting/tax-payment-form",
                    name: "tax-payment-form",
                    props: true,
                    component: () =>
                        import("./components/Accounting/Tax/TaxPaymentForm.vue")
                },
                {
                    path: "/accounting/billing-RE-form",
                    name: "billing-RE-form",
                    props: true,
                    component: () =>
                        import("./components/Accounting/Tax/BillingREForm.vue")
                },
                //realized-gain-loss
                {
                    path: "/",
                    props: true,
                    component: () =>
                        import("./views/Accounting/RealizedGainLossLayout.vue"),
                    children: [
                        {
                            path: "/realized-gain-loss-list",
                            name: "realized-gain-loss-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/RealizedGainLoss/RealizedGainLossList.vue"
                                )
                        },
                        {
                            path: "/realized-gain-loss-form",
                            name: "realized-gain-loss-form",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/RealizedGainLoss/RealizedGainLossForm.vue"
                                )
                        }
                    ]
                },
                //statement
                {
                    path: "/",
                    props: true,
                    component: () =>
                        import("./views/Accounting/StatementLayout.vue"),
                    children: [
                        {
                            path: "/account/statement",
                            name: "statement-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Accounting/Bank/StatementList.vue"
                                )
                        }
                    ]
                },
                {
                    path: "/account/statement-form",
                    name: "statement-form",
                    props: true,
                    component: () =>
                        import("./components/Accounting/Bank/StatementData.vue")
                },
                {
                    path: "/account/statement-month-form",
                    name: "statement-month-form",
                    props: true,
                    component: () =>
                        import(
                            "./components/Accounting/Bank/StatementMonthData.vue"
                        )
                },
                //HR
                {
                    path: "/",
                    props: true,
                    component: () =>
                        import("./views/HR/WorkScheduleLayout.vue"),
                    children: [
                        {
                            path: "/hr/work-schedules",
                            name: "work-schedules",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/WorkSchedules/WorkScheduleList.vue"
                                )
                        },
                        {
                            path: "/hr/leave-day",
                            name: "leave-day",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/WorkSchedules/LeaveDayList.vue"
                                )
                        },
                        {
                            path: "/hr/holidays",
                            name: "holidays",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/WorkSchedules/HolidaysList.vue"
                                )
                        },
                        {
                            path: "/hr/shift",
                            name: "shift-list",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/WorkSchedules/ShiftList.vue"
                                )
                        }
                    ]
                },
                {
                    path: "/hr/work-schedule-form",
                    name: "work-schedule-form",
                    props: true,
                    component: () =>
                        import(
                            "./components/Person/HR/WorkSchedules/WorkScheduleForm.vue"
                        )
                },
                {
                    path: "/",
                    props: true,
                    component: () => import("./views/HR/EmployeeLayout.vue"),
                    children: [
                        {
                            path: "/hr/employee",
                            name: "employee",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/Employee/EmployeeList.vue"
                                )
                        },
                        {
                            path: "/hr/rate-salary",
                            name: "rate-salary",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/Employee/RateSalaryList.vue"
                                )
                        },
                        {
                            path: "/hr/sale-bonus",
                            name: "sale-bonus",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/Employee/SaleBonusList.vue"
                                )
                        },
                        {
                            path: "/hr/work-schedule-history",
                            name: "work-schedule-history",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/Employee/WorkScheduleHistoryList.vue"
                                )
                        }
                    ]
                },
                {
                    path: "/hr/employee-salary-form",
                    name: "employee-salary-form",
                    props: true,
                    component: () =>
                        import(
                            "./components/Person/HR/Employee/EmployeeHistorySalaryForm.vue"
                        )
                },
                {
                    path: "/",
                    props: true,
                    component: () =>
                        import("./views/HR/ImportWorkTimeEmployeeLayout.vue"),
                    children: [
                        {
                            path: "/hr/import-work-time",
                            name: "import-work-time",
                            props: true,
                            component: () =>
                                import("./views/HR/ImportWorkTime.vue")
                        },
                        {
                            path: "/hr/import-ot-hour",
                            name: "import-ot-hour",
                            props: true,
                            component: () =>
                                import("./views/HR/ImportOtHourList")
                        },
                        {
                            path: "/hr/import-ot-hour-double",
                            name: "import-ot-hour-double",
                            props: true,
                            component: () =>
                                import("./views/HR/ImportOtHourDoubleList")
                        }
                    ]
                },
                {
                    path: "/hr/import-ot-form",
                    name: "import-ot-form",
                    props: true,
                    component: () => import("./views/HR/ImportOTForm")
                },
                {
                    path: "/hr/import-ot-form-double",
                    name: "import-ot-form-double",
                    props: true,
                    component: () => import("./views/HR/ImportOTDoubleForm")
                },
                {
                    path: "/hr/electricity-bill",
                    name: "electricity-bill-list",
                    props: true,
                    component: () =>
                        import(
                            "./components/Person/HR/SalaryPayment/ElectricityBillList.vue"
                        )
                },
                {
                    path: "/hr/payment-salary-history",
                    name: "payment-salary-history",
                    props: true,
                    component: () =>
                        import(
                            "./components/Person/HR/SalaryPayment/PaymentSalaryHistoryList.vue"
                        )
                },
                {
                    path: "/hr/payment-salary-slip",
                    name: "payment-salary-slip",
                    props: true,
                    component: () =>
                        import(
                            "./components/Person/HR/SalaryPayment/PaymentSalarySlip.vue"
                        )
                },

                {
                    path: "/",
                    name: "payment-salary-menu",
                    props: true,
                    component: () => import("./views/HR/SalaryPaymentLayout"),
                    children: [
                        {
                            path: "/hr/payment-salary",
                            name: "payment-salary",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/SalaryPayment/CalculateSalaryList"
                                )
                        },
                        {
                            path: "/hr/rental-fee",
                            name: "rental-fee",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/SalaryPayment/RentalFeeList"
                                )
                        },
                        {
                            path: "/hr/shopping",
                            name: "shopping",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/SalaryPayment/ShoppingList"
                                )
                        },
                        {
                            path: "/hr/advance-payment",
                            name: "advance-payment",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/SalaryPayment/AdvancePaymentList"
                                )
                        },
                        {
                            path: "/hr/other-payment",
                            name: "other-payment",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/SalaryPayment/OtherPaymentList"
                                )
                        },
                        {
                            path: "/hr/other-recive",
                            name: "other-recive",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/SalaryPayment/OtherReciveList"
                                )
                        },
                        {
                            path: "/hr/sumary-payment",
                            name: "sumary-payment",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/SalaryPayment/SumaryPayment"
                                )
                        }
                    ]
                },
                {
                    path: "/hr/shopping-form",
                    name: "shopping-form",
                    props: true,
                    component: () =>
                        import(
                            "./components/Person/HR/SalaryPayment/ShoppingForm.vue"
                        )
                },
                {
                    path: "/hr/other-income-form",
                    name: "other-income-form",
                    props: true,
                    component: () =>
                        import(
                            "./components/Person/HR/SalaryPayment/OtherReciveForm.vue"
                        )
                },
                {
                    path: "/hr/other-payment-form",
                    name: "other-payment-form",
                    props: true,
                    component: () =>
                        import(
                            "./components/Person/HR/SalaryPayment/OtherPaymentForm.vue"
                        )
                },
                {
                    path: "/hr/employee-information",
                    name: "employee-information",
                    props: true,
                    component: () =>
                        import(
                            "./components/Person/HR/Employee/EmployeeInformation.vue"
                        ),
                    children: [
                        {
                            path: "/hr/employee-information/profile",
                            name: "employee-information-profile",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/Employee/EmployeeData.vue"
                                )
                        },
                        {
                            path: "/hr/employee-information/salary",
                            name: "employee-information-salary",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/Employee/EmployeeSalary.vue"
                                )
                        },
                        {
                            path: "/hr/employee-information/quarantee",
                            name: "employee-information-quarantee",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/Employee/EmployeeQuarantee.vue"
                                )
                        },
                        {
                            path: "/hr/employee-information/leaveDay",
                            name: "employee-information-leaveDay",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/Employee/EmployeeLeaveDay.vue"
                                )
                        },
                        {
                            path: "/hr/employee-information/tax",
                            name: "employee-information-tax",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/Employee/EmployeeTax.vue"
                                )
                        },
                        {
                            path: "/hr/employee-information/card_employee",
                            name: "employee-information-card_employee",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/Employee/EmployeeCard.vue"
                                )
                        },

                        /*add 5/5/2020*/
                        {
                            path: "/hr/employee-information/insurance",
                            name: "employee-social-insurance",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/Employee/EmployeeSocialInsurance.vue"
                                )
                        }
                    ]
                },
                {
                    path: "/",
                    props: true,
                    component: () =>
                        import("./views/Factory/FactoryProductLayout.vue"),
                    children: [
                        {
                            path: "/factory-product",
                            name: "factory-product",
                            props: true,
                            component: () =>
                                import("./components/Factory/FactoryList.vue")
                        },
                        {
                            path: "/import-factory-product",
                            name: "import-factory-product",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Factory/ImportFactoryProductList.vue"
                                )
                        },
                        {
                            path: "/export-factory-product",
                            name: "export-factory-product",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Factory/ExportFactoryProductList.vue"
                                )
                        }
                    ]
                },
                {
                    path: "/",
                    props: true,
                    component: () =>
                        import("./views/Factory/FactoryProductSaleLayout.vue"),
                    children: [
                        {
                            path: "/factory-product-sale",
                            name: "factory-product-sale",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Factory/FactoryProductSaleTable.vue"
                                )
                        }
                    ]
                },
                {
                    path: "/factory-sale-form",
                    name: "factory-sale-form",
                    props: true,
                    component: () =>
                        import(
                            "./components/Factory/FactoryProductSaleInformation.vue"
                        )
                },
                {
                    path: "/factory-form",
                    name: "factory-form",
                    props: true,
                    component: () =>
                        import("./components/Factory/FactoryForm.vue")
                },
                {
                    path: "/",
                    props: true,
                    component: () =>
                        import("./views/HR/SettingEmployeeLayout.vue"),
                    children: [
                        {
                            path: "/setting-department",
                            name: "setting-department",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/SalaryPayment/DepartmentEmployeeList.vue"
                                )
                        },
                        {
                            path: "/setting-position",
                            name: "setting-position",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/SalaryPayment/PositionEmployeeList.vue"
                                )
                        },
                        {
                            path: "/setting-tax-rate",
                            name: "setting-tax-rate",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/SalaryPayment/RateTaxPersonTable.vue"
                                )
                        },
                        {
                            path: "/setting-social-security-rate",
                            name: "setting-social-security-rate",
                            props: true,
                            component: () =>
                                import(
                                    "./components/Person/HR/SalaryPayment/RateSocialSecurityTable.vue"
                                )
                        }
                    ]
                }
            ]
        },
        {
            path: "/login",
            name: "login",
            component: () => import("@/views/Login.vue")
        },
        {
            path: "/scan",
            name: "scan",
            component: () => import("@/views/FingerPrintLogin.vue")
        },
        {
            path: "/about",
            name: "about",
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
                import(/* webpackChunkName: "about" */ "./views/About.vue")
        },
        {
            path: "/test",
            name: "test",
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
                import(/* webpackChunkName: "about" */ "./views/Test.vue")
        }
    ]
});
